import { getInjectedProviderFromWindow } from '@dynamic-labs-sdk/client/core';

import type { OkxBitcoinInjectedProvider } from '../OkxBitcoinInjectedProvider.types';

const OKX_BITCOIN_PROVIDER_LOCATOR = 'okxwallet.bitcoin';

export const getOkxBitcoinInjectedProvider = () => {
  return getInjectedProviderFromWindow<OkxBitcoinInjectedProvider>(
    OKX_BITCOIN_PROVIDER_LOCATOR
  );
};
